import { createContext, useState, useEffect } from "react";

export const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
  const [domain, setDomain] = useState(localStorage.getItem("domain") || null);

  useEffect(() => {
    if (domain) localStorage.setItem("domain", domain);
  }, [domain]);

  useEffect(() => {
    localStorage.removeItem("region");
  }, []);

  return (
    <DomainContext.Provider value={{ domain, setDomain }}>
      {children}
    </DomainContext.Provider>
  );
};
